/** The id of the one assertive live region; `<Announcer>` (src/components/announcer.tsx) renders it. */
export const ANNOUNCER_ID = 'app-announcer';

/** How long the region stays empty before the message, so a repeated message is a change and is read again. */
const CLEAR_FOR_MS = 50;

let pending: number | undefined;

/**
 * Says a failure to screen readers at once, through the persistent assertive live region. A region that is created
 * with its text already in it (as orno's toast is) is often not read at all; this one is on the page from the start
 * and only its text changes.
 */
export function announce(message: string): void {
  const region = document.getElementById(ANNOUNCER_ID);
  if (region === null) return;
  window.clearTimeout(pending);
  region.textContent = '';
  pending = window.setTimeout(() => {
    region.textContent = message;
  }, CLEAR_FOR_MS);
}
